export default "__VITE_ASSET__f642941f__"